let commonValues = {
    "language": { "kr": "한국어", "en": "English", "pt": "Português", "tw": "繁體中文", "cn": "简体中文"},
    "lang-kr": {
        "kr": "한국어",
        "en": "Korean",
        "pt": "Coreano",
        "tw": "韓語",
        "cn": "韩语",
        "id": "Korean",
    },
    "lang-en": {
        "kr": "영어",
        "en": "English",
        "pt": "Inglês",
        "tw": "英語",
        "cn": "英语",
        "id": "English",
    },

    "lang-pt": {
        "kr": "포르투갈어",
        "en": "Portuguese",
        "pt": "Português",
        "tw": "葡萄牙語",
        "cn": "葡萄牙语",
        "id": "Portuguese",
    },
    "lang-tw": {
        "kr": "대만어",
        "en": "Chinese (Traditional)",
        "pt": "Chinês (Tradicional)",
        "tw": "繁體中文",
        "cn": "繁体中文",
        "id": "Taiwan",
    },
    "lang-cn": {
        "kr": "중국어",
        "en": "Chinese (Simplified)",
        "pt": "Chinês (Simplificado)",
        "tw": "簡體中文",
        "cn": "简体中文",
        "id": "Chinese",
    },
    "lang-id": {
        "kr": "인도네시아어",
        "en": "Indonesian",
        "pt": "",
        "tw": "",
        "cn": "",
        "id": "Indonesian",
    },
    "privacy": {
        "kr": "대한민국",
        "en": "Privacy Policy",
        "de": "Datenschutzrichtlinie",
        "es": "Política de privacidad",
        "fr": "Politique de confidentialité",
        "jp": "個人情報保護方針",
        "pt": "Política de Privacidade",
        "ru": "политика конфиденциальности",
        "th": "นโยบายส่วนบุคคล",
        "tw": "個人情報政策"
    },
    "service": {
        "kr": "대한민국",
        "en": "Terms of Service",
        "de": "Nutzungsbedingungen",
        "es": "Condiciones del servicio",
        "fr": "Conditions d'utilisation",
        "jp": "利用規約",
        "pt": "Termos de Uso",
        "ru": "Условия эксплуатации",
        "th": "เงื่อนไขการให้บริการ",
        "tw": "伺服器條款"
    },
    //2022-06-23 update
    //2022-06-24 update
    "link_copyed_txt": {
        "kr": "Link Copied!",
        "en": "Link Copied!",
        "de": "Link kopiert!",
        "fr": "Lien copié !",
        "es": "¡Link Copiado!",
        "pt": "Link Copiado!",
        "ru": "Скопировано!",
        "th": "คัดลอกลิงค์เรียบร้อย!",
        "jp": "コピー完了",
        "tw": "已複製連結"
    },
    "success_pre_msg": {
        "kr": "사전예약 완료",
        "en": "PRE-REGISTRATION COMPLETE",
        "de": "VORREGISTRIERUNG ABGESCHLOSSEN",
        "fr": "PRÉ-INSCRIPTION COMPLÈTE",
        "es": "PREINSCRIPCIÓN COMPLETA",
        "pt": "PRÉ-REGISTRO CONCLUÍDO",
        "ru": "ПРЕ-РЕГИСТРАЦИЯ ЗАВЕРШЕНА",
        "th": "ลงทะเบียนล่วงหน้าเรียบร้อย",
        "jp": "事前登録完了",
        "tw": "預約成功。"
    },
    "success_share_msg": {
        "kr": "공유 링크가 저장되었습니다.",
        "en": "Your shared link has been submitted.",
        "de": "Dein geteilter Link wurde übermittelt.",
        "fr": "Votre lien de partage a été enregistré. ",
        "es": "Tu link de comparte fue entregue.",
        "pt": "O link de seu compartilhamento foi salvo.",
        "ru": "Вам предоставлена ссылка для освещения.",
        "th": "ลงทะเบียนลิงค์เรียบร้อย",
        "jp": "共有URLを保存しました。",
        "tw": "分享連結儲存完畢。"
    },
    //2022-06-24 update: en
    "preview_txt": {
        "kr": "미리보기",
        "en": "PREVIEW",
        "de": "VORSCHAU",
        "fr": "APERÇU",
        "es": "PREVIA",
        "pt": "PRÉVIA",
        "ru": "ПРЕВЬЮ",
        "th": "พรีวิวตัวละคร",
        "jp": "プレビュー",
        "tw": "預覽"
    },
    "server_txt": {
        "kr": "서버",
        "en": "SERVER",
        "de": "SERVER",
        "fr": "SERVEUR",
        "es": "SERVIDOR",
        "pt": "SERVIDOR",
        "ru": "СЕРВЕР",
        "th": "เซิร์ฟเวอร์",
        "jp": "サーバー",
        "tw": "伺服器"
    },
    "email_address_txt": {
        "kr": "이메일 주소",
        "en": "EMAIL ADDRESS",
        "de": "E-MAIL-ADRESSE",
        "fr": "ADRESSE E-MAIL",
        "es": "CORREO ELECTRÓNICO",
        "pt": "EMAIL",
        "ru": "АДРЕС ПОЧТЫ",
        "th": "อีเมล์",
        "jp": "Eメールアドレス",
        "tw": "E-mail地址"
    },
    "game_no_txt": {
        "kr": "게임회원번호",
        "en": "Game Membership No.",
        "de": "Spiel-Mitgliedsnummer",
        "fr": "N° d'abonnement au jeu",
        "es": "Número de Registro del Jugador",
        "pt": "Nº de Registro do Jogador",
        "ru": "№ Членства игрока",
        "th": "หมายเลขสมาชิกเกม",
        "jp": "会員番号",
        "tw": "遊戲會員編號"
    },
    //2022-06-23 update
    //2022-06-24 update
    "posting_url_txt": {
        "kr": "Posting URL",
        "en": "Social Media Post URL",
        "de": "URL des Social-Media-Beitrags",
        "fr": "Lien de la publication des réseaux sociaux",
        "es": "Link de Post en Red Social",
        "pt": "Link do Post da Rede Social",
        "ru": "URL для поста в социальных сетях",
        "th": "ลิงค์โพสต์",
        "jp": "掲載したURL",
        "tw": "貼上連結"
    },
    "submit_txt": {
        "kr": "제출",
        "en": "SUBMIT",
        "de": "EINREICHEN",
        "fr": "SOUMETTRE",
        "es": "ENVIAR",
        "pt": "ENVIAR",
        "ru": "ОТПРАВИТЬ",
        "th": "ลงทะเบียน",
        "jp": "提出",
        "tw": "提交"
    },
    "login_now_txt": {
        "kr": "지금 로그인",
        "en": "LOGIN NOW",
        "de": "JETZT EINLOGGEN",
        "fr": "CONNECTEZ-VOUS MAINTENANT",
        "es": "CONÉCTATE AHORA",
        "pt": "CONECTE-SE AGORA",
        "ru": "ЗАХОДИТЕ СЕЙЧАС",
        "th": "เข้าเกมเลย",
        "jp": "今すぐログイン",
        "tw": "立即登入遊戲"
    },
    "play_now_txt": {
        "kr": "지금 플레이하기",
        "en": "PLAY NOW",
        "de": "JETZT SPIELEN",
        "fr": "JOUEZ MAINTENANT",
        "es": "JUEGA AHORA",
        "pt": "JOGUE AGORA",
        "ru": "ИГРАЙТЕ УЖЕ СЕЙЧАС",
        "th": "เข้าเล่นเกมกันเถอะ!",
        "jp": "今すぐプレイ",
        "tw": "立即進行遊戲"
    }
}

export { commonValues }